import React, { Fragment, useContext, useState } from "react";
import { Form, FormGroup, Input } from "reactstrap";
import ChatAppContext from "../../../Chat";

const SearchChatList = () => {
  const { searchMember } = useContext(ChatAppContext) || {};
  const [searchKeyword, setSearchKeyword] = useState("");

  const handleSearchKeyword = (keyword) => {
    setSearchKeyword(keyword);
    searchMember(keyword);
  };
  // Added by Aman Maurya
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <Fragment>
      <div className="search">
        <Form className="theme-form" onSubmit={handleSubmit}>
          <FormGroup className="form-group">
            <Input
              className="form-control"
              type="text"
              placeholder="search"
              value={searchKeyword}
              onChange={(e) => handleSearchKeyword(e.target.value)}
            />
            <i className="fa fa-search"></i>
          </FormGroup>
        </Form>
      </div>
    </Fragment>
  );
};

export default SearchChatList;
